var _style, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightLossMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA6;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F8EEE1;}\n\t.st2{fill:#EFC05D;}\n\t.st3{fill:none;stroke:#2A384F;stroke-width:4.2396;stroke-miterlimit:10;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#D4E1D9;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#DBD3C8;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#1C8078;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#2A384F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.5,156H73.1c-6.7,0-12.1-5.4-12.1-12.1V73.7c0-6.7,5.4-12.1,12.1-12.1h66.5c6.7,0,12.1,5.4,12.1,12.1v70.2 C151.7,150.6,146.2,156,139.5,156z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.3,97.8l-15.1-7.7c6.3-12.4,18.8-20.1,32.7-20.1c0,0,0,0,0,0c13.9,0,26.4,7.7,32.7,20.1l-15.1,7.7 c-3.4-6.8-10-10.8-17.6-10.8C99.3,87,92.8,91.1,89.3,97.8z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 106.9,
    y1: 81.8,
    x2: 106.9,
    y2: 99.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85,127.9h42.4c1.2,0,2.1,1,2.1,2.2v17c0,1.2-1,2.2-2.1,2.2H85c-1.2,0-2.1-1-2.1-2.2v-17 C82.9,128.9,83.8,127.9,85,127.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M85,106.6h42.4c1.2,0,2.1,1,2.1,2.2v16.9c0,1.2-1,2.2-2.1,2.2H85c-1.2,0-2.1-1-2.1-2.2v-16.9 C82.9,107.6,83.8,106.6,85,106.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.6,127.9h43.3c1,0,1.9-0.6,2.1-1.4l2.8-10.8c0.1-0.6,0-1.1-0.4-1.5c-0.4-0.4-1-0.7-1.7-0.7h-49 c-0.7,0-1.2,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.4,1.5l2.8,10.8C82.7,127.3,83.6,127.9,84.6,127.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M104.5,136.7H93.2c-0.1,0-0.3,0-0.5,0c0.4-2.4,2.8-3.9,4.8-5.2c1.7-1.1,3.5-2.2,4.8-3.7h-2.6 c-0.8,0.7-1.7,1.3-2.6,1.8c-3.4,2.3-6.4,4.1-6.7,8.7h13.9V136.7L104.5,136.7z M109.6,127.9c-1.4,1-2.2,2.6-2.2,4.5 c0,3.9,2.8,6.4,7.2,6.4c4.5,0,7.3-2.5,7.3-6.5c0-1.9-0.8-3.4-2.1-4.4H116c2.5,0.4,4,2.1,4,4.5c0,2.9-2.1,4.8-5.3,4.8 c-3.2,0-5.3-1.9-5.3-4.8c0-2.3,1.5-4,3.9-4.5H109.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102.4,127.9c0.6-0.5,1.1-1.1,1.4-1.7c0.3-0.7,0.5-1.4,0.5-2.3c0-1.6-0.8-3-2-4c-1.3-1-3.2-1.6-5.4-1.6 c-2.4,0-4.2,0.7-5.3,1.9c-1.1,1.2-1.5,2.8-1.1,4.8c0,0.1,0,0.2,0,0.2c0.6,0,1.3,0,1.9,0c-0.2-1.4-0.1-2.6,0.5-3.6 c0.7-1,1.9-1.6,3.9-1.6c1.5,0,2.9,0.4,3.8,1.1c0.9,0.7,1.5,1.7,1.5,2.9c0,0.9-0.2,1.7-0.7,2.3c-0.5,0.6-1.1,1.2-1.8,1.7 C100.6,127.9,101.5,127.9,102.4,127.9L102.4,127.9z M109.5,127.9c1.2,0,2.5,0,3.7,0c0.4-0.1,0.9-0.1,1.4-0.1c0.5,0,1,0,1.4,0.1 c1.3,0,2.5,0,3.8,0c-0.6-0.3-1.3-0.6-2.1-0.7c1.1-0.3,2.1-0.8,2.8-1.4c0.7-0.7,1.2-1.5,1.4-2.5c0.3-1.4-0.2-2.7-1.3-3.6 c-1.1-0.9-2.8-1.4-5-1.4s-4,0.5-5.3,1.5c-1.3,0.9-2,2.2-2,3.6c0,1,0.3,1.8,0.9,2.5c0.6,0.6,1.4,1.1,2.5,1.4 C110.9,127.3,110.2,127.5,109.5,127.9L109.5,127.9z M115.5,119.9c1.6,0,2.7,0.3,3.5,1c0.7,0.6,1.1,1.5,0.9,2.5 c-0.2,1-0.8,1.8-1.6,2.4c-0.9,0.5-2.1,0.8-3.5,0.8c-1.4,0-2.5-0.3-3.3-0.8c-0.8-0.5-1.2-1.3-1.2-2.4c0.1-1.1,0.6-1.9,1.5-2.5 C112.7,120.2,114,119.9,115.5,119.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightLossMaintenance);
export default __webpack_public_path__ + "static/media/WeightLoss_Maintenance.f049d5b775dfe5a8cb2afeae54805534.svg";
export { ForwardRef as ReactComponent };